export default class SaveProposalStateError extends Error {
    
}
